module.exports = __webpack_public_path__ + "img/64.9f9bd127.jpeg";